'use client';

export { default } from './Skeleton';
export * from './skeletonClasses';
export { default as skeletonClasses } from './skeletonClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Skeleton/index.js
// module id = 569
// module chunks = 25